import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { ranking } from '@/mocks/home';

export default function HostRanking() {
  const podium = ranking.slice(0, 3);

  return (
    <section id="ranking" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="人气主播榜"
          title="本周人气主播与网红达人榜"
          desc="综合开播时长、互动热度、口碑与内容更新频率，每周更新一次。"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
              <div className="flex items-center gap-4 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-medium text-foreground-500">
                <span className="w-8 shrink-0">排名</span>
                <span className="flex-1">主播 / 简介</span>
                <span className="hidden w-24 shrink-0 text-right sm:block">综合指数</span>
              </div>
              <ul>
                {ranking.map((item, index) => (
                  <li key={item.rank}>
                    <Reveal delay={(index % 5) * 50}>
                      <div className="flex cursor-pointer items-center gap-4 border-b border-background-200/70 px-5 py-4 transition-colors last:border-b-0 hover:bg-background-100">
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                            item.rank <= 3
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-background-200 text-foreground-700'
                          }`}
                        >
                          {item.rank}
                        </span>
                        <div className="min-w-0 flex-1">
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="font-heading text-base font-bold text-foreground-950">{item.name}</span>
                            <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                              {item.tag}
                            </span>
                          </div>
                          <p className="mt-1 line-clamp-1 text-xs text-foreground-600 sm:text-sm">{item.summary}</p>
                        </div>
                        <span className="hidden w-24 shrink-0 text-right font-heading text-lg font-bold text-primary-600 sm:block">
                          {item.score}
                        </span>
                      </div>
                    </Reveal>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="sticky top-24 rounded-xl border border-background-200 bg-background-100 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-trophy-line text-lg" />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">本榜前三速览</h3>
              </div>

              <ul className="mt-5 flex flex-col gap-3">
                {podium.map((item) => (
                  <li
                    key={item.rank}
                    className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3"
                  >
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                      {item.rank}
                    </span>
                    <div className="min-w-0">
                      <p className="font-heading text-sm font-bold text-foreground-950">{item.name}</p>
                      <p className="truncate text-[11px] text-foreground-500">{item.tag}</p>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="mt-5 rounded-lg bg-secondary-50 p-4">
                <p className="text-xs leading-relaxed text-foreground-700">
                  <strong className="font-medium text-secondary-900">榜单说明：</strong>
                  指数由开播时长、弹幕与礼物互动、内容更新频率和用户口碑加权得出，仅反映平台站内活跃度。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}